module.exports = __webpack_public_path__ + "static/media/TRIPLANAR MKVII U2 CLASSIC.436e733e.png";